module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray",
    staticStyle: {
      "padding-bottom": "2.44rem"
    }
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "shop-top"
  }, [_c('div', {
    staticClass: "shop-info"
  }, [_c('div', {
    staticClass: "left-info"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.entity.shopName) + "("), _c('span', {
    class: _vm.stateCss
  }, [_vm._v(_vm._s(_vm.shopActState))]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "addr"
  }, [_vm._v(_vm._s(_vm.entity.address))])])]), _vm._v(" "), _c('div', {
    staticClass: "top-setting"
  }, [_c('div', {
    staticClass: "setting-item bd-bot"
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v(" 开门声音")]), _vm._v(" "), _c('div', {
    staticClass: "item-range"
  }, [_c('van-slider', {
    attrs: {
      "ar-height": "4px",
      "active-color": "#83C221"
    },
    on: {
      "change": function($event) {
        return _vm.valueChange($event, 1)
      }
    },
    model: {
      value: (_vm.entity.doorVolumeNum),
      callback: function($$v) {
        _vm.$set(_vm.entity, "doorVolumeNum", $$v)
      },
      expression: "entity.doorVolumeNum"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-rang-num"
  }, [_vm._v(_vm._s(_vm.entity.doorVolumeNum))])]), _vm._v(" "), _c('div', {
    staticClass: "setting-item bd-bot"
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v(" 广告声音")]), _vm._v(" "), _c('div', {
    staticClass: "item-range"
  }, [_c('van-slider', {
    attrs: {
      "ar-height": "4px",
      "active-color": "#83C221"
    },
    on: {
      "change": function($event) {
        return _vm.valueChange($event, 2)
      }
    },
    model: {
      value: (_vm.entity.advertVolumeNum),
      callback: function($$v) {
        _vm.$set(_vm.entity, "advertVolumeNum", $$v)
      },
      expression: "entity.advertVolumeNum"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-rang-num"
  }, [_vm._v(_vm._s(_vm.entity.advertVolumeNum))])]), _vm._v(" "), _c('div', {
    staticClass: "setting-item bd-bot"
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v(" 温度")]), _vm._v(" "), _c('div', {
    staticClass: "item-range"
  }, [_c('van-slider', {
    attrs: {
      "min": -20,
      "max": 70,
      "ar-height": "4px",
      "active-color": "#83C221"
    },
    on: {
      "change": function($event) {
        return _vm.valueChange($event, 3)
      }
    },
    model: {
      value: (_vm.entity.temperature),
      callback: function($$v) {
        _vm.$set(_vm.entity, "temperature", $$v)
      },
      expression: "entity.temperature"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-rang-num"
  }, [_vm._v(_vm._s(_vm.entity.temperature) + "℃")])]), _vm._v(" "), _c('div', {
    staticClass: "setting-item"
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v(" 门锁状态")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-right"
  }, [_vm._v(_vm._s(_vm.entity.shopOffState == '0' ? '释放' : '锁住'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "2.2rem"
    }
  }, [_c('div', {
    staticClass: "setting-item click bd-bot",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'equipmentSettingInfo',
          query: {
            shop: JSON.stringify(_vm.entity),
            type: 'name'
          }
        })
      }
    }
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v(" 名称")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.entity.shopName))]), _vm._v(" "), _c('div', {
    staticClass: "item-right-icon alifont icon-fanhui1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "setting-item click bd-bot",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'equipmentSettingInfo',
          query: {
            shop: JSON.stringify(_vm.entity),
            type: 'address'
          }
        })
      }
    }
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v(" 地址")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.areaName + _vm.entity.address))]), _vm._v(" "), _c('div', {
    staticClass: "item-right-icon alifont icon-fanhui1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "setting-item click bd-bot",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'equipmentSettingInfo',
          query: {
            shop: JSON.stringify(_vm.entity),
            type: 'lnglat'
          }
        })
      }
    }
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v(" 经纬度")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.entity.lng + '  ' + _vm.entity.lat))]), _vm._v(" "), _c('div', {
    staticClass: "item-right-icon alifont icon-fanhui1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "setting-item click",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'equipmentSettingInfo',
          query: {
            shop: JSON.stringify(_vm.entity),
            type: 'sn'
          }
        })
      }
    }
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v(" SN码")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.entity.deviceSn))]), _vm._v(" "), _c('div', {
    staticClass: "item-right-icon alifont icon-fanhui1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "setting-item click",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'equipmentSettingInfo',
          query: {
            shop: JSON.stringify(_vm.entity),
            type: 'deviceVersionId'
          }
        })
      }
    }
  }, [_c('div', {
    staticClass: "item-name"
  }, [_vm._v(" 设备版本")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.entity.deviceVersionName))]), _vm._v(" "), _c('div', {
    staticClass: "item-right-icon alifont icon-fanhui1"
  })])]), _vm._v(" "), (_vm.entity.equipmentType == 'weigh') ? _c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "btn click",
    on: {
      "click": function($event) {
        return _vm.updatePriceShow()
      }
    }
  }, [_vm._v("同步价签")]), _vm._v(" "), _c('div', {
    staticClass: "btn click",
    staticStyle: {
      "margin-right": ".3rem"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'equipmentPeel',
          query: {
            shopId: _vm.shopId
          }
        })
      }
    }
  }, [_vm._v("去皮设置")]), _vm._v(" "), _c('div', {
    staticClass: "btn click",
    on: {
      "click": function($event) {
        return _vm.reloadSys()
      }
    }
  }, [_vm._v("重启系统")])]) : _vm._e(), _vm._v(" "), (_vm.entity.equipmentType != 'weigh') ? _c('div', {
    staticClass: "click run-btn",
    on: {
      "click": function($event) {
        return _vm.reloadSys()
      }
    }
  }, [_vm._v("重启系统")]) : _vm._e(), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.actions
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.actionShow),
      callback: function($$v) {
        _vm.actionShow = $$v
      },
      expression: "actionShow"
    }
  }), _vm._v(" "), _c('navs', {
    attrs: {
      "shopId": _vm.shopId
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f75925c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/equipment/equipmentSetting.vue
// module id = ctor
// module chunks = 51